import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpCacheKeyPrefix, HttpExtras } from '@lib/core';
import { EnvService } from '@lib/env';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DemandIncotermDataService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);

    public updateIncoterm(demandId: string, supplierCompanyId: string, incotermCode: string): Observable<void> {
        const uri = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'incoterm');
        return this.http.post<void>(
            uri.toString(),
            { incotermCode },
            { params: HttpExtras.PRUNE_CACHE_WITH_PREFIX(HttpCacheKeyPrefix.DEMAND) },
        );
    }

    public deleteIncoterm(demandId: string, supplierCompanyId: string): Observable<void> {
        const uri = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'incoterm');
        return this.http.delete<void>(uri.toString(), {
            params: HttpExtras.PRUNE_CACHE_WITH_PREFIX(HttpCacheKeyPrefix.DEMAND),
        });
    }
}
